import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Chip, CircularProgress } from '@mui/material';
import { CuriosityNamespaceType, CuriosityValue, useCuriosityTranslationLoader } from '@procureai/curiosity-ui-mui';
import { useFileStorage } from '@procureai/uix';

export interface UploadedFile {
  fileId: string;
}
export interface UploadedFileListProps extends UploadedFile {
  isLoading?: boolean;
  onDelete?: (file: UploadedFile) => void;
}

export const UploadedFileListItem = ({ fileId, isLoading, onDelete }: UploadedFileListProps) => {
  const { download } = useFileStorage();
  const { load } = useCuriosityTranslationLoader();
  const handleDelete = () => {
    if (isLoading) return;
    onDelete?.({ fileId });
  };
  const handleDownload = async () => {
    if (isLoading) return;
    const entity = await load(CuriosityNamespaceType.FILE, fileId);
    download({ uploadId: fileId, fileName: entity?.value ?? fileId });
  };

  return (
    <Chip
      sx={{ width: 'fit-content' }}
      icon={<InsertDriveFileOutlinedIcon fontSize="small" />}
      label={<CuriosityValue ns={CuriosityNamespaceType.FILE} i18nKey={fileId} />}
      onClick={handleDownload}
      onDelete={onDelete ? handleDelete : undefined}
      deleteIcon={isLoading ? <CircularProgress size={22} /> : undefined}
    />
  );
};
